export default __webpack_public_path__ + "static/media/digital-agency-poster-image-01.5bab66a1.jpg";